import type { ReactNode } from 'react';

export interface Choice<T extends string> { value: T; label: ReactNode; description?: ReactNode; disabled?: boolean }

/** Lista de opções em cartões (rádio ou múltipla escolha) — C-16. */
export default function ChoiceGroup<T extends string>({ options, value, onChange, multiple, columns = 1, ariaLabel }: {
  options: Choice<T>[];
  value: T | T[] | null | undefined;
  onChange: (v: any) => void;
  multiple?: boolean;
  columns?: 1 | 2 | 3;
  ariaLabel?: string;
}) {
  const selected = (v: T) => (multiple ? ((value as T[]) ?? []).includes(v) : value === v);
  const toggle = (v: T) => {
    if (!multiple) return onChange(v);
    const cur = (value as T[]) ?? [];
    onChange(cur.includes(v) ? cur.filter((x) => x !== v) : [...cur, v]);
  };
  return (
    <div role={multiple ? 'group' : 'radiogroup'} aria-label={ariaLabel} className={columns > 1 ? `grid c${columns}` : 'stack'} style={{ ['--gap' as string]: '8px' }}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role={multiple ? 'checkbox' : 'radio'}
          aria-checked={selected(o.value)}
          disabled={o.disabled}
          className={`choice ${multiple ? 'square' : ''} ${selected(o.value) ? 'sel' : ''}`}
          onClick={() => toggle(o.value)}
        >
          <span className="dot" aria-hidden />
          <span>
            {o.label}
            {o.description && <span className="desc">{o.description}</span>}
          </span>
        </button>
      ))}
    </div>
  );
}
